// extracted by mini-css-extract-plugin
export var dropdownButton = "_1g-0";
export var fullWidthDropdownButton = "_1g-1";
export var icon = "_1g-3";
export var iconPlaceholder = "_1g-2";
export var menuItemRow = "_1g-5";
export var shortcutContainer = "_1g-4";